
import { Link } from 'react-router-dom';

export default function WisdomSection() {
  const wisdomCategories = [
    {
      icon: "ri-heart-3-line",
      title: "おもてなしの心",
      description: "相手を思いやる心こそ、最高のサービスの源泉。真心から生まれる温かなおもてなし。",
      link: "/wisdom/hospitality"
    },
    {
      icon: "ri-goblet-line", 
      title: "フォーマルマナー",
      description: "社交の場で輝く、洗練されたエチケット。品格ある振る舞いで信頼を築く。",
      link: "/wisdom/etiquette"
    },
    {
      icon: "ri-star-line",
      title: "執事スキル", 
      description: "プロフェッショナルとしての技術と心構え。完璧を追求する職人精神。",
      link: "/wisdom/butler-skills"
    },
    {
      icon: "ri-leaf-line",
      title: "日常の品格",
      description: "日々の所作に宿る、美しい生き方。何気ない瞬間にも現れる真の教養。",
      link: "/wisdom/elegance"
    }
  ];

  return (
    <section id="wisdom" className="py-32 bg-white relative overflow-hidden">
      {/* Elegant background pattern */}
      <div className="absolute inset-0 opacity-3">
        <div className="absolute top-20 left-1/4 w-64 h-64 border border-amber-400 rounded-full"></div>
        <div className="absolute bottom-20 right-1/4 w-48 h-48 border border-amber-400 rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 border border-amber-400 rounded-full"></div>
      </div>

      <div className="max-w-6xl mx-auto px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center mb-8">
            <div className="w-20 h-px bg-amber-400"></div>
            <span 
              className="mx-8 text-amber-600 text-sm tracking-[0.3em] font-light uppercase"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              Wisdom of Butler
            </span>
            <div className="w-20 h-px bg-amber-400"></div>
          </div>
          
          <h2 
            className="text-5xl md:text-6xl font-light text-gray-900 mb-8 tracking-wide"
            style={{ 
              fontFamily: '"Noto Serif JP", serif',
              letterSpacing: '0.02em'
            }}
          >
            一流のおもてなしを学ぶ
          </h2>
          
          <p 
            className="text-xl text-gray-600 font-light max-w-6xl mx-auto leading-relaxed"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              lineHeight: '1.8'
            }}
          >
            執事として培った知識と経験を、皆様にお届けします。<br />
            日々の生活に品格を添える智慧をご紹介いたします。
          </p>
        </div>

        {/* Wisdom Grid */}
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          {wisdomCategories.map((category, index) => (
            <Link
              key={index}
              to={category.link}
              className="group relative bg-gray-50 hover:bg-white p-10 transition-all duration-500 hover:shadow-xl cursor-pointer border border-gray-100 hover:border-amber-400/30 block"
            >
              {/* Icon Container */}
              <div className="mb-8">
                <div className="relative inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-amber-400 to-amber-500 rounded-full group-hover:scale-110 transition-transform duration-500">
                  {/* Icon glow effect */}
                  <div className="absolute inset-0 bg-amber-400 rounded-full blur-lg opacity-0 group-hover:opacity-30 transition-opacity duration-500"></div>
                  
                  <i className={`${category.icon} text-3xl text-white relative z-10`}></i>
                  
                  {/* Decorative ring */}
                  <div className="absolute -inset-2 border border-amber-400/30 rounded-full group-hover:border-amber-400/60 transition-colors duration-500"></div>
                </div>
              </div>

              {/* Content */}
              <div>
                <h3 
                  className="text-2xl font-light text-gray-900 mb-4 group-hover:text-amber-600 transition-colors duration-300"
                  style={{ 
                    fontFamily: '"Noto Serif JP", serif',
                    letterSpacing: '0.02em'
                  }}
                >
                  {category.title}
                </h3>
                
                <p 
                  className="text-gray-600 leading-relaxed font-light"
                  style={{ 
                    fontFamily: '"Noto Sans JP", sans-serif',
                    lineHeight: '1.8'
                  }}
                >
                  {category.description}
                </p>
              </div>

              {/* Hover accent line */}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-amber-400 to-amber-500 group-hover:w-full transition-all duration-500"></div>
              
              {/* Corner decorations */}
              <div className="absolute top-4 right-4 w-6 h-6 border-r border-t border-amber-400/20 group-hover:border-amber-400/60 transition-colors duration-500"></div>
              <div className="absolute bottom-4 left-4 w-6 h-6 border-l border-b border-amber-400/20 group-hover:border-amber-400/60 transition-colors duration-500"></div>
            </Link>
          ))}
        </div>

        {/* View All Wisdom Button */}
        <div className="text-center">
          <Link
            to="/wisdom"
            className="group relative inline-flex items-center border-2 border-amber-400 text-amber-600 hover:bg-amber-800 hover:text-white px-12 py-4 font-light text-lg transition-all duration-500 overflow-hidden cursor-pointer"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              letterSpacing: '0.1em'
            }}
          >
            <span className="relative z-10 mr-3">View All Wisdom</span>
            <i className="ri-arrow-right-line relative z-10 text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
            
            {/* Hover background */}
            <div className="absolute inset-0 bg-amber-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
            
            {/* Decorative elements */}
            <div className="absolute -top-1 -left-1 w-6 h-6 border-l-2 border-t-2 border-amber-400/40 group-hover:border-white/60 transition-colors duration-500"></div>
            <div className="absolute -bottom-1 -right-1 w-6 h-6 border-r-2 border-b-2 border-amber-400/40 group-hover:border-white/60 transition-colors duration-500"></div>
          </Link>
        </div>
      </div>

      {/* Section divider */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-40 h-px bg-gradient-to-r from-transparent via-amber-400/50 to-transparent"></div>
    </section>
  );
}
